import { render, staticRenderFns } from "./InactiveStorePanel.vue?vue&type=template&id=71b4f4e9&scoped=true"
import script from "./InactiveStorePanel.vue?vue&type=script&lang=js"
export * from "./InactiveStorePanel.vue?vue&type=script&lang=js"
import style0 from "./InactiveStorePanel.vue?vue&type=style&index=0&id=71b4f4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4f4e9",
  null
  
)

export default component.exports